import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialVectorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {vec3} from "#material/types/vector"
import {z} from "zod/v4-mini"

export interface CombineXyzSockets extends MaterialNodeSockets {
    inputs: {
        x: "float" // found in inputs: float; found in settings: float; inferred from data: float
        y: "float" // found in inputs: float; found in settings: float; inferred from data: float
        z: "float" // found in inputs: color; found in settings: float; inferred from data: float
    }
    settings: {
        vector: "vector" // found in inputs: -; found in settings: vector; inferred from data: float3
        x: "float" // found in inputs: float; found in settings: float; inferred from data: float
        y: "float" // found in inputs: float; found in settings: float; inferred from data: float
        z: "float" // found in inputs: color; found in settings: float; inferred from data: float
    }
    outputs: {
        vector: "vector"
    }
}

export const combineXyzDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeCombineXYZ,
    },
    nodeClass: "CombineXyz",
    ui: {
        label: "Combine XYZ",
        color: "#4987af",
        items: [
            {valueType: "vector", label: "Image", name: "vector", output: true},
            {valueType: "float", label: "X", name: "x", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
            {valueType: "float", label: "Y", name: "y", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
            {valueType: "float", label: "Z", name: "z", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({vector: materialVectorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({
                x: optionalMaterialInput,
                y: optionalMaterialInput,
                z: optionalMaterialInput,
            }),
            settings: z.strictObject({
                x: z.optional(z.number()),
                vector: z.optional(vec3),
                y: z.optional(z.number()),
                z: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<CombineXyzSockets>
